import axios from 'axios';
import {saveAs} from 'file-saver';

export function downloadPDF(url) {
    let arrayFile = url.split('/')
    let size = arrayFile.length

    return axios.get(url, {responseType: 'blob'})
        .then(response => {
            let blob = new Blob([response.data], {type: " text/plain;charset=utf-8 "});
            saveAs(blob, arrayFile[size - 1])
        }).catch(console.error);
}


export async function getImageCertificate(videoId) {
    const url = '/elearning/certificate/generate/image?videoID=' + videoId;
    return await axios.post(url, null, {
        headers: {'Content-Type': 'application/json'},
        withCredentials: true,
    })
}
